import React, { useState, useEffect } from 'react';
import { db, collection, addDoc, auth, storage } from '../LoginComp/firebase';
import { useNavigate } from 'react-router-dom'; 
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import './abstract.css';

import bgImage from "../../assets/background_image_conference.jpg";


function AbstractSubmission() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactNo: "",
    title: "",
    abstract: "",
    fileUrl: "" // Store uploaded file URL
  });
  const [user, setUser] = useState(null);
  const [file, setFile] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        setUser(authUser);
        setFormData((prevData) => ({ ...prevData, email: authUser.email }));
      } else {
        setUser(null);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };


  
const handleSubmit = async (e) => {
  e.preventDefault();
  if (!user) {
    alert("Please sign in to submit an abstract.");
    navigate("/signin");
    return;
  }
  try {
    let fileUrl = "";
    if (file) {
      const fileRef = ref(storage, `abstracts/${user.uid}/${file.name}`);
      await uploadBytes(fileRef, file);
      fileUrl = await getDownloadURL(fileRef);
    }
    // Add status: "pending" when submitting
    await addDoc(collection(db, "abstracts"), { 
      ...formData, 
      fileUrl,
      status: "pending", // Add this line
      createdAt: new Date() // Optional: add timestamp
    });
    alert("Abstract submitted successfully!");
    setFormData({ name: "", email: user.email, contactNo: "", title: "", abstract: "", fileUrl: "" });
    setFile(null);
  } catch (error) {
    console.error("Error adding document: ", error);
    alert("Error submitting abstract. Please try again.");
  }
};



  if (!user) {
    return (
      <div className="abstract-container-top-layer">
        <h2 className="abstract-title">Abstract Submission</h2>
        <div className="speaker-abstract-layout">
      <div className="speaker-invite-container">
        <h2 style={{ textAlign: 'center'}}>Invitation to Deliver a Speech at EYE CARE 2027 Conference</h2>
        <p>
          It is our honour and pleasure to invite you as a speaker at{' '}
          <strong>
            S A A R C &nbsp; Optometric Conference in Sri Lanka
          </strong>{' '}
          to be held in Colombo, Sri Lanka on{' '}
          <strong>23rd & 24th January 2027</strong>, hosted by the Eye Care
          Institute (ECI) alongside with Ceylon Eye Care Optometric Association
          (CECOA).
        </p>
<p>
  We are pleased to inform you that the deadline for abstract submission has been extended until <strong>30th October 2026</strong>.
</p>

        <ul>
          <li>Portrait Photograph (in high resolution)</li>
          <li>Short Personal Profile</li>
          <li>Abstract</li> 
          <li>Highlights & topics</li>
          <li>Video message</li>
        </ul>
        <p>
          <strong>Presentation Duration:</strong> 10-minute presentation &
          2-minute discussion.
        </p>
        <p>
          All PowerPoint slides and other files for the presentation must be
          submitted on-site in the Preview room,{' '}
          <strong>2 hours prior</strong> to the start of the presentation
          session.
        </p>
        <p>
          Presenters will <strong>not</strong> be allowed to use their own
          laptop.
        </p>
        <p>
          For general questions about the program, your presentation, etc.,
          contact <strong>Himidira</strong> at <strong>+94 77 559 4518</strong>.
        </p>
        <p>
          We look forward to your support to make this event a grand success.
          Please accept our thanks in advance for your generosity.
        </p>
        <br />
        <p>
          <strong>Optom. Narresh Pradhan</strong>
        </p>
        <p>
          <em>Event Chairperson</em>
        </p>
      </div>

      <div className="speaker-invite-container">
        <h2 style={{ textAlign: 'center'}}>Selection criteria and requirements</h2>
        <p>All abstracts must meet the following requirements:</p>
        <ol>
          <li>Primary authors must be an eye care professional.</li>
          <li>
            The complete abstract must be submitted online by 30th October 2026.
          </li>
          <li>
            In the Clinical Lecture, the Abstract is submitted in one paragraph
            containing the sub-title: Background, Clinical problem(s), Existing
            solution(s) & its shortcoming, Clinical pearls, Take home message.
          </li>
          <li>
            In the Case Study, the Abstract is submitted in one paragraph
            containing the sub-title: Patient description, Case history,
            Physical examination results, Results of pathological tests and
            other investigations, Treatment plan, Expected outcome of the
            treatment plan, and Actual outcome.
          </li>
          <li>
            In the Original Research, the Abstract is submitted in one paragraph
            containing the following sub-titles: Introduction, Methods, Results
            and Conclusions.
          </li>
          <li>
            The abstract must be no more than 350 words (not including title
            and authors);
          </li>
          <li>
            The Committee reserves the right to publish the accepted abstracts
            in official publications of the Conference.
          </li>
          <li>
            Research involving human subjects must have received ethical
            approval and be conducted in accordance with the tenets of the
            Declaration of Helsinki. This statement should be acknowledged in
            either the oral presentation slides or on the poster.
          </li>
          <li>
            In case reports, subjects must be de-identified, and if images of
            the subject are used, identifying features should be obscured. The
            patient described in the case report must provide permission for
            their clinical data and images to be used.
          </li>
        </ol>
        <p>
          Receipt of abstracts will be sent to the email provided. Notification
          for acceptance of abstracts will be made approximately one month
          after the closing date for abstract submissions.
        </p>
      </div>
    </div>


        <p style={{ textAlign: 'center', backgroundColor: 'yellow' }}>Please <a href="/signin"><b>Sign In</b></a> or <a href="/signup"><b>Sign Up</b></a> to submit an abstract.</p>
      </div>
    );
  }


  return (
    <div className="abstract-container">





      <h2 className="abstract-title">S A A R C  Optometry Conference Abstract Submission</h2>
      <form onSubmit={handleSubmit}>
        <div className="abstract-group">
          <label className="abstract-label">Name:</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="abstract-input"
            required
          />
        </div>
        <div className="abstract-group">
          <label className="abstract-label">Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="abstract-input"
            required
            readOnly // Make email read-only
          />
        </div>

        <div className="abstract-group">
          <label className="abstract-label">Contact No:</label>
          <input
            type="tel"
            name="contactNo"
            value={formData.contactNo}
            onChange={handleChange}
            className="abstract-input"
            required
          />
        </div>


        <div className="abstract-group">
          <label className="abstract-label">Title:</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="abstract-input"
            required
          />
        </div>
        <div className="abstract-group">
          <label className="abstract-label">Abstract:</label>
          <textarea
            name="abstract"
            value={formData.abstract}
            onChange={handleChange}
            className="abstract-input abstract-textarea"
            required
          ></textarea>
        </div>

        <div className="abstract-group">
        <label className="abstract-label">Upload PDF/DOCX:</label>
        <input type="file" accept=".pdf,.docx" onChange={handleFileChange} className="abstract-input" required />
      </div>

        <button type="submit" className="abstract-btn">Submit</button>
      </form>
    </div>
  );
}

export default AbstractSubmission;
